import {Typography} from "@material-ui/core";
import {colors} from "../../colors";
import SortingBySelect from "../../../components/ui/inputs/selects/sorting-by-select/SortingBySelect";
import React from "react";
import './SortingDropdown.css';
import PropTypes from "prop-types";

const SortingDropdown = (props) => {
    return (
        <div className="d-inline-block">
            <div className="sorting-block-left">
                <Typography className="ordina-per-label" variant="body2" style={{color: colors.font.light}}>Ordina per</Typography>
                <SortingBySelect value={props.sortingValue} changeSortingCriteria={props.changeSortingCriteria} selectItems={props.sortingCriteria}/>
            </div>
        </div>
    )
}

SortingDropdown.propTypes = {
    sortingValue: PropTypes.string.isRequired,
    changeSortingCriteria: PropTypes.func.isRequired,
    sortingCriteria: PropTypes.array.isRequired
}

export default SortingDropdown;
